export default "__VITE_ASSET__44b2cff9__"